<template>
  <QCard :class="['column', { 'full-width': $q.screen.lt.md }]">
    <QForm @submit="$emit('sendResetPasswordEmail')" class="q-pa-lg q-ma-md">
      <PageHeader class="q-pb-md">
        <div class="col-12 q-mb-xs">
          <HeaderBackBtn @click="$emit('logIn', $event)" />
        </div>
        <h4 class="col-12">Reset Your Password</h4>
      </PageHeader>
      <SAIFormError v-if="errors.$error" class="q-mt-md q-mb-sm" />
      <SAIFormError v-if="!errors.$error && formError" class="q-mt-md q-mb-sm">
        {{ formError }}
      </SAIFormError>
      <SAIMessage
        v-if="successMessage"
        variant="positive"
        class="q-mt-md q-mb-sm"
      >
        {{ successMessage }}
      </SAIMessage>
      <div class="column">
        <SAIEmailInput
          :value="email"
          large
          :disable="disable"
          :error="errors.email.$error"
          @input="$emit('update:email', $event)"
        />
        <p class="q-px-sm q-mt-md text-center text-body3 text-grey-6">
          The email should be the one used to sign up
        </p>
        <div class="row justify-center q-mt-lg">
          <SAIBtn
            padding="11px 48px"
            size="16px"
            label="Reset Password"
            :no-caps="true"
            :disable="disable"
            type="submit"
            :loading="loading"
          />
        </div>
      </div>
    </QForm>
    <QSpace />
    <SignUpCardAction @click="$emit('logIn')">
      <span>Back to Log In</span>
    </SignUpCardAction>
  </QCard>
</template>

<script>
import {
  SAIBtn,
  SAIEmailInput,
  SAIFormError,
  SAIMessage
} from 'ecx.saigon.ui.common';
import { QForm, QCard, QSpace } from 'quasar';

export default {
  name: 'ResetPassword',
  props: {
    email: String,
    loading: Boolean,
    formError: String,
    disable: Boolean,
    successMessage: String,
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    QCard,
    QForm,
    SAIBtn,
    SAIEmailInput,
    SAIFormError,
    SAIMessage,
    QSpace,
    SignUpCardAction: () => import('../../atom/sign-up-card-action'),
    HeaderBackBtn: () => import('../../atom/header-back-btn'),
    PageHeader: () => import('../../atom/page-header')
  }
};
</script>
